import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { BreadcrumbsModule } from '@exalif/ngx-breadcrumbs';

import { HomeComponent } from './pages/home/home.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { MunicipalitiesComponent } from './pages/municipalities/municipalities.component';

import { IndicatorsComponent } from './pages/indicators/indicators.component';
import { PublicationsComponent } from './pages/publications/publications.component';
import { PublicationDetailsComponent } from './pages/publications/publication-details/publication-details.component';
import { LibrariesComponent } from './pages/libraries/libraries.component';
import { NewsComponent } from './pages/news/news.component';
import { AgnoskojComponent } from './pages/agnoskoj/agnoskoj.component';
import { NewsDetailsComponent } from './pages/news/news-details/news-details.component';

import { CapitalsComponent } from './pages/capitals/capitals.component';
import { StatesComponent } from './pages/states/states.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GoodPracticesComponent } from './pages/good-practices/good-practices.component';
import { GoodPracticesDetailsComponent } from './pages/good-practices/good-practices-details/good-practices-details.component';
import { PdfBookViewerComponent } from './pages/pdf-book-viewer/pdf-book-viewer.component';




const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },


  {
    path: 'nosotros',
    loadChildren: './pages/about/about.module#AboutModule',
    data: {
      title: 'Nosotros',
      breadcrumbs: true,
      text: 'Nosotros'
    }
  },

  {
    path: 'ICTRC/departamentos',
    component: ProjectsComponent,
    data: {
      title: 'Departamentos',
      breadcrumbs: true,
      text: 'Departamentos'
    }
  },

  {
    path: 'ICTRC/municipios',
    component: MunicipalitiesComponent,
    data: {
      title: 'Municipios',
      breadcrumbs: true,
      text: 'Municipios'
    }
  },

  

  {
    path: 'ICTRC/capitales',
    component: CapitalsComponent,
    data: {
      title: 'Capitales',
      breadcrumbs: true,
      text: 'Capitales'
    }
  },

  {
    path: 'estados',
    component: StatesComponent,
    data: {
      title: 'Estados',
      breadcrumbs: true,
      text: 'Estados'
    }
  },

  {
    path: 'reconocimientos',
    component: AgnoskojComponent,
    data: {
      title: 'Reconocimientos',
      breadcrumbs: true,
      text: 'Reconocimientos'
    }
  },

  {
    path: 'publicaciones',
    component: PublicationsComponent,
    data: {
      title: 'Publicaciones',
      breadcrumbs: true,
      text: 'Publicaciones'
    }
  },

  {
    path: 'publicaciones/visualizar',
    component: PdfBookViewerComponent,
    data: {
      title: 'Visualizar documento',
      breadcrumbs: true,
      text: 'Visualizar'
    }
  },
  {
    path: 'publicaciones/:token',
    component: PublicationDetailsComponent,
    data: {
      title: 'Publicaciones',
      breadcrumbs: true,
      text: 'Publicaciones'
    }
  },

  {
    path: 'biblioteca',
    component: LibrariesComponent,
    data: {
      title: 'Biblioteca',
      breadcrumbs: true,
      text: 'Biblioteca'
    }
  },

  {
    path: 'noticias',
    component: NewsComponent,
    data: {
      title: 'Noticias',
      breadcrumbs: true,
      text: 'Noticias'
    }
  },

  {
    path: 'contacto',
    component: ContactComponent,
    data: {
      title: 'Contacto',
      breadcrumbs: true,
      text: 'Contacto'
    }
  },

  {
    path: 'noticias/:token',
    component: NewsDetailsComponent,
    data: {
      title: 'Noticias',
      breadcrumbs: true,
      text: 'Noticias'
    }
  },

  {
    path: 'practicas',
    component: GoodPracticesComponent,
    data: {
      title: 'Buenas practicas',
      breadcrumbs: true,
      text: 'Buenas practicas'
    }
  },

  {
    path: 'practicas/:token',
    component: GoodPracticesDetailsComponent,
    data: {
      title: 'Practicas',
      breadcrumbs: true,
      text: 'Practicas'
    }
  },

  {
    path: ':token',
    redirectTo: 'publicaciones/:token',
    pathMatch: 'full'
  },

  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    BreadcrumbsModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
